import {ServerApi} from "./api.js";
import {askWhyBanUser, handleFetchError, showNotice} from "./helpers/functions.js";
import {IBanJson, IEditJson, IUserJsonNicknameAndAva} from "../../../nodeserver/structs/database";
import JSX from "./helpers/react.js";
import RefObject = JSX.RefObject;

async function loadBans() {
    const button = $('#load-banned-history');
    if (button.hasClass('blocked')) return;
    button.addClass('blocked')
        .html('<i class="loading"></i> Загрузка');
    const $container = $('.banned-container');
    let unban = true;
    try {
        const lastId = ($container.length) ? $container.children().last().data('id') : undefined;
        const bans = await ServerApi.users.getBannedUsers({start_from: lastId});
        for (const ban of bans)
            IBannedItem.createElement(ban, $container);
        unban = !!bans.length;
    } catch (e: any) {
        handleFetchError(e);
    } finally {
        button.text('Загрузить').removeClass('blocked');
        if (!unban)
            button.text('Конец').addClass('blocked');
    }
}

// $(window).on("load", loadBans);

$(document)
    .on('click', '#block-user', async function () {
        if (page_type !== 'user') return;
        await banUser(page_id!, $('.second-marker:eq(1)').text())
    })
    .on('click', '#unblock-user', async function () {
        if (page_type !== 'user') return;
        await unbanUser(page_id!);
    })
    .on('click', '#load-banned-history', loadBans)

async function unbanUser(userId: number) {
    try {
        if (!confirm("Вы уверены, что хотите разблокировать пользователя?\nЗа несогласованные разблокировки вы можете получить бан!")) return;
        await ServerApi.users.unbanUser(userId);
        showNotice("Пользователь успешно разблокирован", 'Успех');
        window.location.reload()
    } catch (e) {
        handleFetchError(e);
    }
}

async function banUser(userId: number, nickName: string) {
    try {
        const [until, reason] = await askWhyBanUser(nickName, true, '');
        await ServerApi.users.banUser(userId, {reason, until: Math.floor(+new Date / 1000) + until});
        showNotice("Пользователь успешно заблокирован", 'Успех', 'error');
        window.location.reload();
    } catch (e) {
        handleFetchError(e);
    }
}

function ReasonDate({data}: { data: IBanJson }) {
    return (
        <>
            {data.ban.active ? ' до ' : (data.ban.is_unban ? false : ' от ')}
            <local-time data-time={data.ban.end}></local-time>
            {!!data.ban.reason && ':'}
        </>
    )

}

class IBannedItem {
    private readonly $element: JQuery;

    private constructor(private readonly data: IBanJson) {
        this.$element = this.buildHtml();
    }

    private buildHtml(): JQuery {
        const $ans = $(
            <li className="ban-update" data-id={this.data.ban.id}>
                <div className="ban-avatar"><img src={this.data.user.avatars.small} className="bordered" width="50"
                                                 height="50" style={{minWidth: "50px", minHeight: "50px"}}/></div>
                <div className="ban-data">
                    <a className="nickname" href={`/users/id${this.data.user.id}`}
                       target="_blank">{this.data.user.nickname}</a>
                    {this.data.ban.is_unban ? <span className="unbanned"> разблокирован</span> :
                        <span className="banned"> заблокирован</span>} модером <a className="nickname"
                                                                                  href={`/users/id${this.data.moderator.id}`}
                                                                                  target="_blank">@{this.data.moderator.nickname}</a>
                    <ReasonDate data={this.data}/>
                    {!!this.data.ban.reason && <gray className="ban-reason"> {this.data.ban.reason}</gray>}
                </div>
                <span title={this.data.ban.active ? 'Активна' : 'Неактивна'} className="ban-status">
        <i className="fa fa-circle" style={{color: `var(${this.data.ban.active ? '--main-green' : '--main-red'})`}}/>
    </span>
            </li>
        );
        return $ans;
    }

    public appendTo($parent: JQuery) {
        this.$element.appendTo($parent);
    }

    public static createElement(data: IBanJson, $parent: JQuery): IBannedItem {
        const ans = new IBannedItem(data);
        ans.appendTo($parent);
        return ans;
    }
}


let loadOffet: number = 0;
$(document)
    .on('click', '#load-edits', async function () {
        if ($(this).hasClass('blocked')) return;
        $(this).addClass('blocked');
        try {
            loadOffet = await loadData(loadOffet);
        } catch (e) {
            handleFetchError(e);
        } finally {
            $(this).removeClass('blocked');
        }
    })
    .on('click', '#export-edits', exportData);


const AllEdits: IEditJson[] = [];

async function loadData(offset: number) {
    try {
        const edits = await ServerApi.getEdits({offset, limit: 30});
        const els = edits.map(e => (<OneEdit edit={e}/>));
        document.querySelector('#edits .content')!.append(...els);
        AllEdits.push(...edits);
        return offset + 30;
    } catch (e) {
        handleFetchError(e);
        return offset;
    }
}

function downloadTextAsFile(filename: string, text: string): void {
    // Create a Blob object from the text
    const blob = new Blob([text], {type: 'text/plain'});

    // Create a link element
    const link = document.createElement('a');

    // Set the URL of the link to the Blob object
    const url = URL.createObjectURL(blob);
    link.href = url;

    // Set the download attribute of the link
    link.download = filename;

    document.body.appendChild(link);

    // Trigger a click event on the link to start the download
    link.click();

    // Clean up the URL object
    URL.revokeObjectURL(url);

    // Remove the link from the document
    document.body.removeChild(link);
}

function exportData() {
    let data = `Аниме,ID аниме,Дата,Лайкнули,Дислайнули,Количество полей\n`;
    for (const i of AllEdits) {
        data += `${i.anime.title.replaceAll(',', ' ')},${i.anime.anime_id},${new Date(i.date * 1000).toISOString()},${i.who_voted.likes.map(e => e.nickname).join('/')},${i.who_voted.dislikes.map(e => e.nickname).join('/')},${i.edits_count}\n`
    }
    downloadTextAsFile('data.csv', data);
}

function showLikes(data: IUserJsonNicknameAndAva[], element: RefObject<HTMLDivElement>) {
    if (element.value!.nextElementSibling?.className === 'who-voted') {
        element.value!.nextElementSibling!.remove();
    } else {
        element.value!.parentElement!.insertBefore(<div className="who-voted">
                {
                    ...data.map(user => (
                        <a className="user-vote" href={`/users/id${user.id}`} data-balloon={user.nickname}
                           data-balloon-pos="up">
                            <img src={user.avatars.small} width={20} height={20} style={{borderRadius: "10px"}}/>
                        </a>
                    ))
                }
            </div>, element.value!.nextElementSibling
        )
    }
}

function OneEdit({edit}: { edit: IEditJson }) {
    const dislikes: RefObject<HTMLDivElement> = {}, likes: RefObject<HTMLDivElement> = {};
    return (
        <div className="one-moder-edit">
            <a href={`/catalog/view-edit/${edit.edit_id}`} target="_blank">
                <img src={edit.anime.poster.small} alt="..." className="bordered"/>
            </a>
            <div className="cont">
                <a className="title" href={`/catalog/view-edit/${edit.edit_id}`}>{edit.anime.title}</a>
                <div className="data">
                    <local-time style={{color: '#919191', width: 'auto'}} data-time={edit.date}/>
                    <div className="likes" onClick={() => showLikes(edit.who_voted.likes, likes)} ref={likes}><i
                        className="likes far fa-thumbs-up">{edit.who_voted.likes.length}</i></div>
                    <div className="dislikes" onClick={() => showLikes(edit.who_voted.dislikes, dislikes)}
                         ref={dislikes}><i className="dislikes far fa-thumbs-down">{edit.who_voted.dislikes.length}</i>
                    </div>
                    <div className={"status " + edit.status}>
                        {{'open': 'В процессе', 'applied': 'Принята', 'declined': 'Отклонена'}[edit.status]}
                    </div>
                    <div className="edits-count" data-balloon="Полей изменено"
                         data-balloon-pos="left">{edit.edits_count}</div>
                </div>
            </div>

            <a className="user" href={`/users/id${edit.creator.id}`} data-balloon={edit.creator.nickname}
               data-balloon-pos="left">
                <span>{edit.creator.nickname}</span>
                <img className="bordered" src={edit.creator.avatars.small}/>
            </a>

        </div>
    )
}